import { FB_MESSENGER_GENERIC_CHANNEL_ID } from 'conversations-thread-data/generic-channels/public/constants';
export const isFacebookMessengerGenericChannel = genericChannelId => {
  return genericChannelId === FB_MESSENGER_GENERIC_CHANNEL_ID;
};